import type { INoraTranslationsFormat } from '../../interfaces/i18n'

import { createEffect } from 'effector'

//GET /v3/i18n
export const getAllFx = createEffect<void, INoraTranslationsFormat>()
